// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuppliersModal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30%;
  height: 80%;
  background-color: white;
  border: 2px solid #ccc;
  border-radius: 5px;
  box-shadow: 24;
  padding: 10px !important;
}

.modalHeader {
  height: 30px;
  margin-left: 10px;
  margin-right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.suppliersContainer {
  height: 80%;
  margin: 10px;
  margin-top: 30px;
  overflow-y: scroll;
  scroll-behavior: smooth;
  /* display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap; */
}

.cardParent {
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/berthsModal/BerthsModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB;;;;oBAIkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".SuppliersModal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 30%;\n  height: 80%;\n  background-color: white;\n  border: 2px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 24;\n  padding: 10px !important;\n}\n\n.modalHeader {\n  height: 30px;\n  margin-left: 10px;\n  margin-right: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.suppliersContainer {\n  height: 80%;\n  margin: 10px;\n  margin-top: 30px;\n  overflow-y: scroll;\n  scroll-behavior: smooth;\n  /* display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap; */\n}\n\n.cardParent {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
